import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g><rect x=\"1\" y=\"1\" width=\"11\" height=\"11\" rx=\"0.923077\" stroke=\"#D4002B\" stroke-width=\"2\"></rect><path d=\"M12 21.5V26.077C12 26.5868 11.5867 27 11.0769 27H1.92308C1.41328 27 1 26.5868 1 26.077V16.9231C1 16.4133 1.41328 16 1.92308 16H9\" stroke=\"#D4002B\" stroke-width=\"2\" stroke-linecap=\"round\"></path><rect x=\"16\" y=\"16\" width=\"11\" height=\"11\" rx=\"0.923077\" stroke=\"#D4002B\" stroke-width=\"2\"></rect><rect x=\"16\" y=\"1\" width=\"11\" height=\"11\" rx=\"0.923077\" stroke=\"#D4002B\" stroke-width=\"2\"></rect><path d=\"M5 20.5L7 22.5L13 16\" stroke=\"#D4002B\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g>", 1)
  ]))]))
}
export default { render: render }